import { render } from "./Create.vue?vue&type=template&id=801126ac&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=801126ac&scoped=true&lang=css"
import "./Create.vue?vue&type=style&index=1&id=801126ac&lang=css"

import exportComponent from "C:\\Users\\dyamd\\OneDrive\\Documents\\PROYECTOS\\ceramicas\\mi-stock-ceramicas-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-801126ac"]])

export default __exports__